/**
 * Removes trailing slash from url
 *
 * @public
 * @param {string} url
 * @returns {string} URL without trailing slash
 */
export const removeTrailingSlash = (url: string): string => url.replace(/\/+$/, '')
